import { createVNode as _createVNode, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6dc5fef4")

_pushScopeId("data-v-6dc5fef4")
const _hoisted_1 = { class: "flex flex-row gap-x-1" }
const _hoisted_2 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_3 = {
  class: "w-full absolute z-50",
  style: {"border-bottom":"85px solid transparent"}
}
const _hoisted_4 = {
  key: 0,
  class: "flex justify-end p-2"
}
const _hoisted_5 = {
  key: 1,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_6 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_7 = {
  key: 2,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_8 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_9 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_10 = {
  key: 1,
  class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px my-2"
}
const _hoisted_11 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_12 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-row gap-y-4 mx-2 my-4 city-exclude-radio"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "type1",
  class: "cursor-pointer"
}, "Partner", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "type2",
  class: "cursor-pointer"
}, "Client", -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "px-1 py-3 font-semibold flex gap-2 items-end" }
const _hoisted_18 = { class: "flex gap-2 items-end" }
const _hoisted_19 = { class: "px-1 py-1 font-semibold flex gap-2 items-end" }
const _hoisted_20 = { class: "flex gap-2 items-end" }
const _hoisted_21 = {
  key: 4,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_22 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_23 = { class: "w-1/2 pl-2.5 py-2 border-r border-gray-lp-400" }
const _hoisted_24 = { class: "w-1/2 pl-2.5 py-2" }
const _hoisted_25 = {
  key: 5,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_26 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_27 = {
  key: 6,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Status Pembayaran ", -1)
const _hoisted_29 = {
  key: 7,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_30 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_31 = {
  key: 8,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_32 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_33 = { class: "w-1/2 py-1 pr-1 border-r border-gray-lp-400" }
const _hoisted_34 = { class: "w-1/2 py-1 pl-1" }
const _hoisted_35 = {
  key: 9,
  class: "relative px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Status ", -1)
const _hoisted_37 = { class: "w-full py-4 px-3" }
const _hoisted_38 = { class: "flex flex-row mb-3" }
const _hoisted_39 = { class: "ml-3" }
const _hoisted_40 = {
  key: 0,
  class: "pl-8 overflow-y-scroll"
}
const _hoisted_41 = { class: "ml-3" }
const _hoisted_42 = {
  key: 10,
  class: "relative px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_43 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_44 = { class: "p-field-checkbox" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5",
  for: "binary"
}, "Cash On Delivery", -1)
const _hoisted_46 = {
  key: 0,
  class: "p-field-checkbox mt-1.5"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5",
  for: "binary"
}, "Payment At Delivery", -1)
const _hoisted_48 = {
  key: 1,
  class: "p-field-checkbox mt-1.5"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5",
  for: "binary"
}, "Delivery Fee On Delivery", -1)
const _hoisted_50 = {
  key: 11,
  class: "relative px-1 py-3"
}
const _hoisted_51 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_52 = {
  key: 12,
  class: "relative px-1 py-3"
}
const _hoisted_53 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_54 = {
  key: 13,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_55 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_56 = {
  key: 14,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Created By ", -1)
const _hoisted_58 = {
  key: 15,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Sumber Booking ", -1)
const _hoisted_60 = {
  key: 16,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Komisi Untuk ", -1)
const _hoisted_62 = {
  key: 17,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Shipment ID ", -1)
const _hoisted_64 = { class: "pb-3" }
const _hoisted_65 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_66 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_67 = {
  key: 18,
  class: "px-1 py-3 border-t border-gray-lp-400"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Nama Konsol ", -1)
const _hoisted_69 = {
  key: 19,
  class: "px-1 my-2 py-3 border-t border-gray-lp-400"
}
const _hoisted_70 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_71 = {
  key: 20,
  class: "px-1 my-2 py-3 border-t border-gray-lp-400"
}
const _hoisted_72 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_73 = {
  key: 21,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_74 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_75 = {
  key: 22,
  class: "px-1 py-3 border-t border-gray-lp-400"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Komoditas ", -1)
const _hoisted_77 = {
  key: 23,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Status ", -1)
const _hoisted_79 = { class: "p-field-radiobutton gap-x-3 flex flex-row" }
const _hoisted_80 = { key: 24 }
const _hoisted_81 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Nama Partner ", -1)
const _hoisted_83 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_84 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_85 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_86 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Nama Bank Penerima ", -1)
const _hoisted_87 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Diverifikasi Oleh ", -1)
const _hoisted_89 = { key: 25 }
const _hoisted_90 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_91 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_92 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Nama Bank Penerima ", -1)
const _hoisted_94 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_95 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Diverifikasi Oleh ", -1)
const _hoisted_96 = {
  key: 26,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Status Berita ", -1)
const _hoisted_98 = {
  key: 27,
  class: "px-1 py-3 border-b border-gray-lp-400"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }, " Status Pesan ", -1)
const _hoisted_100 = {
  key: 28,
  class: "flex z-50 sticky bottom-0 pb-2 border-t border-gray-lp-400 bg-white"
}
const _hoisted_101 = { class: "w-6/12 pl-2 pr-1 mt-2" }
const _hoisted_102 = { class: "w-6/12 pr-2 pl-1 mt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_MultipleSelect = _resolveComponent("MultipleSelect")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: 
      `advanced-filter inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2 ${
        _ctx.openFilter
          ? _ctx.isDateRange
            ? 'w-500px'
            : `${_ctx.isSeparateContent ? _ctx.customWidthSeparateContent : _ctx.customWidth || _ctx.customDropdownWidth|| 'w-332px'}`
          : `${_ctx.isSeparateContent ? _ctx.customWidthSeparateContent: _ctx.customWidth || 'w-332px sm:w-32 md:w-32 lg:w-32 xxl:w-32'}`
      }`
    
    }, [
      _createVNode("div", {
        class: 
        `${_ctx.customFilterButton} ${
          _ctx.openFilter && !_ctx.isDisabled && !_ctx.isSeparateContent ? 'rounded-t' : 'rounded'
        } text-gray-lp-300 leading-tight px-3 ${_ctx.customPaddingVerticalHeader} xxl:py-2.5 pr-8 font-normal
         ${_ctx.disabledBackground ? 'bg-gray-lp-1500': ''}`
      ,
        style: {"cursor":"pointer"},
        onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
      }, [
        _createVNode("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createBlock("svg", {
            class: `${_ctx.disabledBackground && 'opacity-50'}`,
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none"
          }, [
            _createVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M3.33334 2.5C3.01897 2.5 2.73135 2.67692 2.58957 2.9575C2.44779 3.23808 2.47597 3.57458 2.66246 3.82767L7.41228 10.2739V16.6667C7.41228 16.9705 7.57764 17.2502 7.84382 17.3967C8.11 17.5432 8.43481 17.5332 8.69149 17.3707L12.2003 15.1485C12.4415 14.9957 12.5877 14.73 12.5877 14.4444V10.2739L17.3376 3.82767C17.524 3.57458 17.5522 3.23808 17.4104 2.9575C17.2687 2.67692 16.981 2.5 16.6667 2.5H3.33334ZM8.9165 9.50567L4.9825 4.16667H15.0175L11.0835 9.50567C10.978 9.64888 10.9211 9.82211 10.9211 10V13.9858L9.07895 15.1525V10C9.07895 9.82211 9.02202 9.64888 8.9165 9.50567Z",
              fill: ((_ctx.sumFilter + _ctx.addSumFilter) !== 0) ? '#B82025' : '#4D4D4D'
            }, null, 8, ["fill"])
          ], 2)), [
            [_vShow, _ctx.showIconFilter]
          ]),
          _createVNode("span", {
            class: `${_ctx.isDisabled && 'opacity-50'} ${_ctx.customTitleFilter}`
          }, [
            _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
            _withDirectives(_createVNode("span", { class: "text-red-lp-100" }, _toDisplayString(_ctx.sumFilter + _ctx.addSumFilter !== 0
                ? `(${_ctx.sumFilter + _ctx.addSumFilter})`
                : ""), 513), [
              [_vShow, _ctx.showCountFilter]
            ])
          ], 2)
        ]),
        _withDirectives(_createVNode("div", _hoisted_2, [
          (_ctx.openFilter)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _imports_0,
                class: `w-4  ${_ctx.sumFilter + _ctx.addSumFilter > 0 ? 'arrow-red' : ''}`,
                alt: "up"
              }, null, 2))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                src: _imports_1,
                class: `w-4  ${_ctx.sumFilter + _ctx.addSumFilter > 0 ? 'arrow-red' : ''}`,
                onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
                alt: "down"
              }, null, 2))
        ], 512), [
          [_vShow, _ctx.showChevron]
        ])
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: 
          `select bg-white border border-t-0 border-gray-lp-400 rounded-b-md px-4 ${_ctx.isScroll &&
            'overflow-y-auto'} overflow-x-show`
        ,
          style: { maxHeight: _ctx.customMaxHeight }
        }, [
          ((_ctx.sumFilter + _ctx.addSumFilter > 0) && _ctx.showResetText)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (!_ctx.isButtonApply)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = () => _ctx.resetfilter(true)),
                      class: "cursor-pointer flex-initial items-end text-red-lp-100"
                    }, " Reset "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCustomDropdown)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.titleCustomDropdown), 1),
                _createVNode(_component_CustomDropdown, {
                  isExpand: _ctx.customDropdownOpened,
                  "onUpdate:isExpand": _cache[4] || (_cache[4] = ($event: any) => (_ctx.customDropdownOpened = $event)),
                  options: _ctx.customDropdownOptions,
                  onSelect: _ctx.onSelectCustomDropdown,
                  placeholder: _ctx.customDropdownPlaceholder,
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.customDropdown
                }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPeriode)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "top", {}, undefined, true),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.isNewPeriodTitle ? _ctx.periodeTitle : _ctx.accountIsNonForeign ? `Periode ${_ctx.periodeTitle}` : `${_ctx.periodeTitle} Period`), 1),
                (_ctx.withMaxMinDate)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_Pickers, {
                        onSelected: _ctx.onChange,
                        modelValue: _ctx.filterData.periodeStart,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterData.periodeStart = $event)),
                        placeholder: _ctx.$t('bookingShipment.placeholderSelect.selectDate'),
                        class: "w-full mb-1 picker",
                        onMonthChange: _cache[6] || (_cache[6] = () => (_ctx.isChevron = true)),
                        maxDate: _ctx.maxStartDatePeriode
                      }, null, 8, ["onSelected", "modelValue", "placeholder", "maxDate"]),
                      (!_ctx.isPeriodeStartOnly)
                        ? (_openBlock(), _createBlock(_component_Pickers, {
                            key: 0,
                            onSelected: _ctx.onChange,
                            modelValue: _ctx.filterData.periodeEnd,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterData.periodeEnd = $event)),
                            placeholder: _ctx.$t('bookingShipment.placeholderSelect.selectDate'),
                            class: "w-full picker",
                            onMonthChange: _cache[8] || (_cache[8] = () => (_ctx.isChevron = true)),
                            maxDate: _ctx.maxEndDatePeriode,
                            minDate: _ctx.filterData.periodeStart
                          }, null, 8, ["onSelected", "modelValue", "placeholder", "maxDate", "minDate"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_Pickers, {
                        onSelected: _ctx.onChange,
                        modelValue: _ctx.filterData.periodeStart,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filterData.periodeStart = $event)),
                        placeholder: _ctx.$t('bookingShipment.placeholderSelect.selectDate'),
                        class: "w-full mb-1 picker",
                        onMonthChange: _cache[10] || (_cache[10] = () => (_ctx.isChevron = true))
                      }, null, 8, ["onSelected", "modelValue", "placeholder"]),
                      (!_ctx.isPeriodeStartOnly)
                        ? (_openBlock(), _createBlock(_component_Pickers, {
                            key: 0,
                            onSelected: _ctx.onChange,
                            modelValue: _ctx.filterData.periodeEnd,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterData.periodeEnd = $event)),
                            placeholder: _ctx.$t('bookingShipment.placeholderSelect.selectDate'),
                            class: "w-full picker",
                            onMonthChange: _cache[12] || (_cache[12] = () => (_ctx.isChevron = true))
                          }, null, 8, ["onSelected", "modelValue", "placeholder"]))
                        : _createCommentVNode("", true)
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("div", {
            class: {
                    'px-1 border-gray-lp-400': true,
                    'border-b': _ctx.isDestination ,
                    'py-3': _ctx.isDestination, 
                    'pt-3': !_ctx.isDestination, 
                  }
          }, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.customSelectCityTitle || _ctx.$t('bookingShipment.column.districtOriginCity')), 1),
            (_ctx.isOrigin)
              ? (_openBlock(), _createBlock(_component_SelectSearchV2, {
                  onChevron: _cache[13] || (_cache[13] = e => (_ctx.isChevron = e)),
                  onFilter: _cache[14] || (_cache[14] = e => _ctx.fetchOriginDestination(e, 'origin')),
                  onFocus: _cache[15] || (_cache[15] = 
              () => {
                _ctx.fetchOriginDestination(_ctx.formOrigin, 'origin');
              }
            ),
                  isLoading: _ctx.loadingOriginDestination,
                  options: _ctx.originList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.customSelectCityPlaceHolder || _ctx.$t('bookingShipment.placeholderSelect.selectDistrictOriginCity'),
                  modelValue: _ctx.form.origin,
                  "onUpdate:modelValue": [
                    _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.origin = $event)),
                    _ctx.onChangeOrigin
                  ],
                  class: "mb-2",
                  key: _ctx.resetSelectSearch
                }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.isDestination)
              ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('bookingShipment.column.districtDestinationCity')), 1))
              : _createCommentVNode("", true),
            (_ctx.isDestination)
              ? (_openBlock(), _createBlock(_component_SelectSearchV2, {
                  onChevron: _cache[17] || (_cache[17] = e => (_ctx.isChevron = e)),
                  onFilter: _cache[18] || (_cache[18] = e => _ctx.fetchOriginDestination(e, 'destination')),
                  onFocus: _cache[19] || (_cache[19] = 
              () => {
                _ctx.fetchOriginDestination(_ctx.formDestination, 'destination');
              }
            ),
                  isLoading: _ctx.loadingOriginDestination,
                  options: _ctx.destinationList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.$t('bookingShipment.placeholderSelect.SelectDistrictDestinationCity'),
                  modelValue: _ctx.form.destination,
                  "onUpdate:modelValue": [
                    _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.destination = $event)),
                    _ctx.onChangeDestination
                  ],
                  key: _ctx.resetSelectSearch
                }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ], 2), [
            [_vShow, _ctx.isOriginDestination]
          ]),
          _withDirectives(_createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.clientPartnerTitle), 1),
            (_ctx.isChooseTypeAccount)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("div", {
                    class: "p-field-radiobutton gap-x-3 flex flex-row",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onChangeRadioValue && _ctx.onChangeRadioValue(...args)))
                  }, [
                    _createVNode(_component_RadioButton, {
                      id: "type1",
                      name: "city-exclude",
                      value: "partner",
                      modelValue: _ctx.radioValue,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.radioValue = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_14
                  ]),
                  _createVNode("div", {
                    class: "p-field-radiobutton ml-2 gap-x-3 flex flex-row",
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onChangeRadioValue && _ctx.onChangeRadioValue(...args)))
                  }, [
                    _createVNode(_component_RadioButton, {
                      id: "type2",
                      name: "city-exclude",
                      value: "client",
                      modelValue: _ctx.radioValue,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.radioValue = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_15
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_SelectSearchV2, {
              onChevron: _cache[25] || (_cache[25] = e => (_ctx.isChevron = e)),
              onFilter: _ctx.fetchClientPartner,
              onFocus: _cache[26] || (_cache[26] = 
              () => {
                _ctx.fetchClientPartner(_ctx.formClient);
              }
            ),
              isLoading: _ctx.loadingClientPartner,
              options: _ctx.clientPartnerData,
              keyName: "name",
              keyValue: "code",
              placeholder: _ctx.clientPartnerPlaceholder,
              modelValue: _ctx.form.client,
              "onUpdate:modelValue": [
                _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.client = $event)),
                _ctx.onChangeClient
              ],
              key: _ctx.resetSelectSearch,
              isDisabled: !_ctx.radioValue && _ctx.isChooseTypeAccount
            }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue", "isDisabled"])
          ], 512), [
            [_vShow, _ctx.isClientPartner]
          ]),
          (_ctx.isPhoneNumber)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.list.filter.shipperPhoneNumber'),
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_18, [
                        _createVNode(_component_SelectPhoneCountry, {
                          column: "Penerima",
                          prefixWidth: "w-2/5",
                          phone: _ctx.phoneSender,
                          code: _ctx.phoneCodeSender,
                          flag: _ctx.phoneFlagSender,
                          onSetPhone: _ctx.setPhoneSender,
                          onSetPhoneCode: _ctx.setPhoneCodeSender,
                          onSetPhoneFlag: _ctx.setPhoneFlagSender
                        }, null, 8, ["phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag"]),
                        _createVNode(_component_lp_button, {
                          disabled: !_ctx.phoneSender,
                          title: _ctx.$t('Cari'),
                          textColor: "white",
                          onClick: _ctx.onSearchPhoneSender
                        }, null, 8, ["disabled", "title", "onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.list.filter.recipientPhoneNumber'),
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_20, [
                        _createVNode(_component_SelectPhoneCountry, {
                          column: "Penerima",
                          prefixWidth: "w-2/5",
                          phone: _ctx.phoneReceiver,
                          code: _ctx.phoneCodeReceiver,
                          flag: _ctx.phoneFlagReceiver,
                          onSetPhone: _ctx.setPhoneReceiver,
                          onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                          onSetPhoneFlag: _ctx.setPhoneFlagReceiver
                        }, null, 8, ["phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag"]),
                        _createVNode(_component_lp_button, {
                          disabled: !_ctx.phoneReceiver,
                          title: _ctx.$t('Cari'),
                          textColor: "white",
                          onClick: _ctx.onSearchPhoneReceiver
                        }, null, 8, ["disabled", "title", "onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isProduct)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, _toDisplayString(_ctx.titleProductCustom), 1),
                _createVNode(_component_custom_dropdown, {
                  placeholder: _ctx.$t('bookingShipment.list.filter.selectServiceType'),
                  value: 
              _ctx.filterData.product.length
                ? `${_ctx.filterData.product.length} ${_ctx.$t('bookingShipment.list.filter.serviceType')}`
                : ''
            
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_23, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "p-field-checkbox mt-1"
                        }, [
                          (index < 5)
                            ? (_openBlock(), _createBlock(_component_Checkbox, {
                                key: 0,
                                name: "product",
                                id: index,
                                value: product.code,
                                modelValue: _ctx.filterData.product,
                                "onUpdate:modelValue": ($event: any) => (_ctx.filterData.product = $event),
                                onClick: _ctx.onChange
                              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onClick"]))
                            : _createCommentVNode("", true),
                          (index < 5)
                            ? (_openBlock(), _createBlock("label", {
                                key: 1,
                                for: index,
                                class: "ml-2.5"
                              }, _toDisplayString(product.name), 9, ["for"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_24, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "p-field-checkbox mt-1.5"
                        }, [
                          (index > 4)
                            ? (_openBlock(), _createBlock(_component_Checkbox, {
                                key: 0,
                                name: "product",
                                id: index,
                                value: product.code,
                                modelValue: _ctx.filterData.product,
                                "onUpdate:modelValue": ($event: any) => (_ctx.filterData.product = $event),
                                onClick: _ctx.onChange
                              }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onClick"]))
                            : _createCommentVNode("", true),
                          (index > 4)
                            ? (_openBlock(), _createBlock("label", {
                                key: 1,
                                for: index,
                                class: "ml-2.5"
                              }, _toDisplayString(product.name), 9, ["for"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["placeholder", "value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isProductDropdown)
            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.titleProductCustomDropdown), 1),
                _createVNode(_component_CustomDropdown, {
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  isDisabled: true,
                  selectedItem: _ctx.filterData.customDropdown,
                  isCustomChevronDisable: _ctx.isCustomDropdownChevronDisabled
                }, null, 8, ["selectedItem", "isCustomChevronDisable"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isStatusPayment)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_CustomDropdown, {
                  isExpand: _ctx.paymentStatusOpen,
                  "onUpdate:isExpand": _cache[28] || (_cache[28] = ($event: any) => (_ctx.paymentStatusOpen = $event)),
                  options: _ctx.paymentStatusOptions,
                  onSelect: _ctx.onSelectPaymentStatus,
                  placeholder: "Pilih status pembayaran",
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.paymentStatus
                }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowDateRange)
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.titleDateRange), 1),
                _createVNode(_component_TimeRangePicker, {
                  class: "w-full",
                  startDate: _ctx.filterData.startDateRange,
                  endDate: _ctx.filterData.endDateRange,
                  onSelect: _ctx.setPeriode,
                  default: _ctx.defaultDateRange,
                  isCloseDateAfterSelect: "",
                  ref: "dateRangeFilter"
                }, null, 8, ["startDate", "endDate", "onSelect", "default"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, " Status " + _toDisplayString(_ctx.isLastStatus ? "Terakhir" : ""), 1),
                _createVNode(_component_custom_dropdown, {
                  placeholder: _ctx.$t('bookingShipment.list.filter.selectStatus'),
                  value: _ctx.filterData.status.length ? _ctx.selectedStatus : '',
                  isExpand: _ctx.statusOpened,
                  "onUpdate:isExpand": _cache[29] || (_cache[29] = ($event: any) => (_ctx.statusOpened = $event))
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_33, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (status, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index.toString()
                        }, [
                          (index < Math.round(_ctx.statusOptions.length / 2))
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: 
                    `w-full py-1 mt-1 pl-2 hover:text-red-lp-100 ${_ctx.filterData.status ===
                      status.value && `text-red-lp-100`}`
                  ,
                                style: {"cursor":"pointer"},
                                onClick: () => _ctx.onSelectStatus(status)
                              }, _toDisplayString(status.name), 11, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_34, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (status, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index.toString()
                        }, [
                          (index > Math.round(_ctx.statusOptions.length / 2 - 1))
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: 
                    `w-full py-1 mt-1 pl-2 hover:text-red-lp-100 ${_ctx.filterData.status ===
                      status.value && `text-red-lp-100`}`
                  ,
                                style: {"cursor":"pointer"},
                                onClick: () => _ctx.onSelectStatus(status)
                              }, _toDisplayString(status.name), 11, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["placeholder", "value", "isExpand"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isNestedStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_custom_dropdown, {
                  placeholder: _ctx.$t('bookingShipment.list.filter.selectStatus'),
                  value: 
                `${
                  _ctx.filterData.nestedStatus.length
                    ? `${_ctx.filterData.nestedStatus.length} Status`
                    : ''
                }`
              ,
                  isExpand: _ctx.statusOpened,
                  "onUpdate:isExpand": _cache[30] || (_cache[30] = ($event: any) => (_ctx.statusOpened = $event)),
                  customClassExpand: "relative block",
                  customClassHeight: ""
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_37, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nestedStatusOptions, (status, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index.toString()
                        }, [
                          _createVNode("div", _hoisted_38, [
                            _createVNode(_component_Checkbox, {
                              binary: "",
                              modelValue: _ctx.isParentSelected(index),
                              onClick: () => _ctx.selectParentStatus(index)
                            }, null, 8, ["modelValue", "onClick"]),
                            _createVNode("button", {
                              class: "w-full flex flex-row justify-between items-center",
                              onClick: ($event: any) => (status.isExpand = !status.isExpand)
                            }, [
                              _createVNode("div", _hoisted_39, _toDisplayString(status.name), 1),
                              _createVNode("img", {
                                src: 
                          require(`@/app/ui/assets/svg/chevron-${
                            status.isExpand ? 'up' : 'down'
                          }.svg`)
                        ,
                                alt: "chevron-up",
                                class: "w-4"
                              }, null, 8, ["src"])
                            ], 8, ["onClick"])
                          ]),
                          (status.isExpand)
                            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(status.children, (child) => {
                                  return (_openBlock(), _createBlock("button", {
                                    key: child.name,
                                    class: "flex flex-row items-center mb-3",
                                    onClick: () => _ctx.selectChildNestedStatus(child.value)
                                  }, [
                                    _createVNode(_component_Checkbox, {
                                      binary: "",
                                      modelValue: 
                          _ctx.filterData.nestedStatus.includes(child.value)
                        
                                    }, null, 8, ["modelValue"]),
                                    _createVNode("div", _hoisted_41, _toDisplayString(child.name), 1)
                                  ], 8, ["onClick"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["placeholder", "value", "isExpand"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCOD)
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("Tipe COD")), 1),
                _createVNode("div", _hoisted_44, [
                  _createVNode(_component_Checkbox, {
                    id: "binary",
                    modelValue: _ctx.filterData.COD,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.filterData.COD = $event)),
                    binary: true,
                    onClick: _ctx.onChange
                  }, null, 8, ["modelValue", "onClick"]),
                  _hoisted_45
                ]),
                (_ctx.isPAD)
                  ? (_openBlock(), _createBlock("div", _hoisted_46, [
                      _createVNode(_component_Checkbox, {
                        id: "binary",
                        modelValue: _ctx.filterData.PAD,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.filterData.PAD = $event)),
                        binary: true,
                        onClick: _ctx.onChange
                      }, null, 8, ["modelValue", "onClick"]),
                      _hoisted_47
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDFOD)
                  ? (_openBlock(), _createBlock("div", _hoisted_48, [
                      _createVNode(_component_Checkbox, {
                        id: "binary",
                        modelValue: _ctx.filterData.DFOD,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.filterData.DFOD = $event)),
                        binary: true,
                        onClick: _ctx.onChange
                      }, null, 8, ["modelValue", "onClick"]),
                      _hoisted_49
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAsuransi)
            ? (_openBlock(), _createBlock("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('bookingShipment.list.filter.shipmentInsurance')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.asuransiOptions, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "p-field-checkbox mt-1.5"
                  }, [
                    _createVNode(_component_Checkbox, {
                      id: `asuransi${index}`,
                      name: "asuransi",
                      value: item.code,
                      modelValue: _ctx.filterData.asuransi,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.filterData.asuransi = $event)),
                      onClick: _ctx.onChange
                    }, null, 8, ["id", "value", "modelValue", "onClick"]),
                    _createVNode("label", {
                      for: `asuransi${index}`,
                      class: "ml-2.5"
                    }, _toDisplayString(_ctx.accountIsForeign ? item.name.replace("Insurance", "") : item.name.replace("Insurance", "")), 9, ["for"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCustomCheckbox)
            ? (_openBlock(), _createBlock("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, _toDisplayString(_ctx.titleCustomCheckbox), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customCheckboxOptions, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "p-field-checkbox mt-1.5"
                  }, [
                    _createVNode(_component_Checkbox, {
                      id: `customCheckbox${index}`,
                      name: "customCheckbox",
                      value: item.value,
                      modelValue: _ctx.filterData.customCheckbox,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.filterData.customCheckbox = $event)),
                      onClick: _ctx.onChange
                    }, null, 8, ["id", "value", "modelValue", "onClick"]),
                    _createVNode("label", {
                      for: `customCheckbox${index}`,
                      class: "ml-2.5"
                    }, _toDisplayString(item.name), 9, ["for"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isType)
            ? (_openBlock(), _createBlock("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, _toDisplayString(_ctx.titleTypeCustom), 1),
                _createVNode(_component_CustomDropdown, {
                  isExpand: _ctx.typeOpened,
                  "onUpdate:isExpand": _cache[36] || (_cache[36] = ($event: any) => (_ctx.typeOpened = $event)),
                  options: _ctx.typeOptions,
                  onSelect: _ctx.onSelectType,
                  placeholder: _ctx.customPlaceholder,
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.type
                }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCreatedBy)
            ? (_openBlock(), _createBlock("div", _hoisted_56, [
                _hoisted_57,
                _createVNode(_component_SelectSearchV2, {
                  placeholder: "Pilih",
                  modelValue: _ctx.form.createdBy,
                  "onUpdate:modelValue": [
                    _cache[37] || (_cache[37] = ($event: any) => (_ctx.form.createdBy = $event)),
                    _ctx.onSelectCreatedBy
                  ],
                  options: _ctx.listActor,
                  onFilter: _ctx.fetchActors,
                  keyName: "createdName",
                  keyValue: "createdId",
                  isLoading: _ctx.isLoadingActors,
                  class: "my-2"
                }, null, 8, ["modelValue", "options", "onFilter", "isLoading", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.bookingSource)
            ? (_openBlock(), _createBlock("div", _hoisted_58, [
                _hoisted_59,
                _createVNode(_component_CustomDropdown, {
                  isExpand: _ctx.bookingSourceOpened,
                  "onUpdate:isExpand": _cache[38] || (_cache[38] = ($event: any) => (_ctx.bookingSourceOpened = $event)),
                  options: _ctx.bookingSourceOptions,
                  onSelect: _ctx.onSelectBookingSource,
                  placeholder: "Pilih sumber booking",
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.bookingSource
                }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.appliedTo)
            ? (_openBlock(), _createBlock("div", _hoisted_60, [
                _hoisted_61,
                _createVNode(_component_CustomDropdown, {
                  isExpand: _ctx.appliedToOpened,
                  "onUpdate:isExpand": _cache[39] || (_cache[39] = ($event: any) => (_ctx.appliedToOpened = $event)),
                  options: _ctx.appliedToOptions,
                  onSelect: _ctx.onSelectAppliedTo,
                  placeholder: "Pilih ",
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.appliedTo
                }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shipmentPrefix)
            ? (_openBlock(), _createBlock("div", _hoisted_62, [
                _hoisted_63,
                _createVNode(_component_SelectSearchV2, {
                  onChevron: _cache[40] || (_cache[40] = e => (_ctx.isChevron = e)),
                  onFilter: _ctx.fetchShipmentId,
                  onFocus: _ctx.fetchShipmentId,
                  options: _ctx.shipmentPrefixOptions,
                  keyName: "name",
                  keyValue: "prefix",
                  placeholder: "Pilih shipment ID",
                  modelValue: _ctx.form.shipmentPrefix,
                  "onUpdate:modelValue": [
                    _cache[41] || (_cache[41] = ($event: any) => (_ctx.form.shipmentPrefix = $event)),
                    _ctx.onChangeShipmentPrefix
                  ],
                  key: _ctx.resetSelectSearch
                }, null, 8, ["onFilter", "onFocus", "options", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: `px-1 ${_ctx.isCityOrigin || _ctx.isCityDestination ? 'py-3' : 'pt-3'}`
          }, [
            _withDirectives(_createVNode("div", _hoisted_64, [
              _createVNode("div", _hoisted_65, _toDisplayString(_ctx.customTitlePlaceholderCity), 1),
              _createVNode(_component_SelectSearchV2, {
                onChevron: _cache[42] || (_cache[42] = e => (_ctx.isChevron = e)),
                onFilter: _ctx.fetchCityOrigin,
                onFocus: _cache[43] || (_cache[43] = 
                () => {
                  _ctx.fetchCityOrigin(_ctx.formCityOrigin);
                }
              ),
                isLoading: _ctx.loadingCityOrigin,
                options: _ctx.cityOriginData,
                keyName: "name",
                keyValue: "code",
                placeholder: `${_ctx.$t('Pilih')} ${_ctx.customTitlePlaceholderCity}`,
                modelValue: _ctx.form.cityOrigin,
                "onUpdate:modelValue": [
                  _cache[44] || (_cache[44] = ($event: any) => (_ctx.form.cityOrigin = $event)),
                  _ctx.onChangeCityOrigin
                ],
                key: _ctx.resetSelectSearch
              }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
            ], 512), [
              [_vShow, _ctx.isCityOrigin]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode("div", _hoisted_66, _toDisplayString(_ctx.customTitlePlaceholderCityDestination), 1),
              _createVNode(_component_SelectSearchV2, {
                onChevron: _cache[45] || (_cache[45] = e => (_ctx.isChevron = e)),
                onFilter: _ctx.fetchCityDestination,
                onFocus: _cache[46] || (_cache[46] = 
                () => {
                  _ctx.fetchCityDestination(_ctx.formCityDestination);
                }
              ),
                isLoading: _ctx.loadingCityDestination,
                options: _ctx.cityDestinationData,
                keyName: "name",
                keyValue: "code",
                placeholder: `${_ctx.$t('Pilih')} ${_ctx.customTitlePlaceholderCityDestination}`,
                modelValue: _ctx.form.cityDestination,
                "onUpdate:modelValue": [
                  _cache[47] || (_cache[47] = ($event: any) => (_ctx.form.cityDestination = $event)),
                  _ctx.onChangeCityDestination
                ],
                key: _ctx.resetSelectSearch
              }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
            ], 512), [
              [_vShow, _ctx.isCityDestination]
            ])
          ], 2),
          (_ctx.isFetchConsolidator)
            ? (_openBlock(), _createBlock("div", _hoisted_67, [
                _hoisted_68,
                (
              _ctx.isFetchConsolidator &&
                _ctx.filterData.cityOriginCode &&
                !_ctx.loadingConsoleData
            )
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (_ctx.consolidatorData.length === 1)
                        ? (_openBlock(), _createBlock(_component_LpInput, {
                            key: 0,
                            modelValue: _ctx.filterData.console.name,
                            disabled: ""
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_CustomDropdown, {
                            key: 1,
                            isExpand: _ctx.isOpenConsole,
                            "onUpdate:isExpand": _cache[48] || (_cache[48] = ($event: any) => (_ctx.isOpenConsole = $event)),
                            options: _ctx.consolidatorData,
                            onSelect: _ctx.onChangeConsole,
                            placeholder: "Pilih nama konsol",
                            class: "w-full custom-select",
                            isCustomWidth: "",
                            selectedItem: _ctx.filterData.console
                          }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"]))
                    ], 64))
                  : (_openBlock(), _createBlock(_component_SelectSearchV2, {
                      key: 1,
                      onFilter: _ctx.filterConsolidatorByCity,
                      isLoading: _ctx.loadingConsoleData,
                      options: _ctx.consolidatorData,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: "Ketik atau pilih nama konsol",
                      modelValue: _ctx.filterData.console,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.filterData.console = $event)),
                      onChange: _ctx.onChangeConsole
                    }, null, 8, ["onFilter", "isLoading", "options", "modelValue", "onChange"]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAirport)
            ? (_openBlock(), _createBlock("div", _hoisted_69, [
                _createVNode("div", _hoisted_70, _toDisplayString(_ctx.customTitlePlaceholderAirportCode), 1),
                _createVNode(_component_SelectSearchV2, {
                  class: "mt-1.5",
                  onFilter: _ctx.fetchAirport,
                  onFocus: _ctx.fetchAirport,
                  isLoading: _ctx.isLoadingAirport,
                  options: _ctx.optionAirport,
                  keyName: "airportName",
                  keyValue: "airportCode",
                  placeholder: `${_ctx.$t('Pilih')} ${_ctx.customTitlePlaceholderAirportCode}`,
                  modelValue: _ctx.form.airport,
                  "onUpdate:modelValue": [
                    _cache[50] || (_cache[50] = ($event: any) => (_ctx.form.airport = $event)),
                    _ctx.onChangeAirport
                  ],
                  key: _ctx.resetSelectSearch
                }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isHub && _ctx.hubIdOptions?.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, _toDisplayString(_ctx.customTitlePlaceholderHubLocation), 1),
                (_ctx.hubIdOptions?.length > 0)
                  ? (_openBlock(), _createBlock(_component_MultipleSelect, {
                      key: 0,
                      modelValue: _ctx.filterData.hubIdSelected,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.filterData.hubIdSelected = $event)),
                      options: _ctx.hubIdOptions,
                      onChange: _ctx.onChangeHubIdSelected,
                      onClear: _ctx.onChangeHubIdSelected
                    }, null, 8, ["modelValue", "options", "onChange", "onClear"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.productBookingShipment)
            ? (_openBlock(), _createBlock("div", _hoisted_73, [
                _createVNode("div", _hoisted_74, _toDisplayString(_ctx.titleProductCustom), 1),
                _createVNode(_component_SelectSearchV2, {
                  onChevron: _cache[52] || (_cache[52] = e => (_ctx.isChevron = e)),
                  onFocus: _ctx.fetchProduct,
                  onFilter: _ctx.filterProduct,
                  isLoading: _ctx.isLoadingProduct,
                  options: _ctx.shipmentProductOptions,
                  keyName: "name",
                  keyValue: "name",
                  placeholder: "Pilih produk",
                  modelValue: _ctx.form.shipmentProduct,
                  "onUpdate:modelValue": [
                    _cache[53] || (_cache[53] = ($event: any) => (_ctx.form.shipmentProduct = $event)),
                    _ctx.onChangeProduct
                  ],
                  key: _ctx.resetSelectSearch
                }, null, 8, ["onFocus", "onFilter", "isLoading", "options", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.commodity)
            ? (_openBlock(), _createBlock("div", _hoisted_75, [
                _hoisted_76,
                _createVNode(_component_SelectSearchV2, {
                  onChevron: _cache[54] || (_cache[54] = e => (_ctx.isChevron = e)),
                  onFocus: _ctx.fetchCommodity,
                  onFilter: _ctx.filterCommodity,
                  isLoading: _ctx.isLoadingCommodity,
                  options: _ctx.commodityOptions,
                  keyName: "commodity_name",
                  keyValue: "commodity_code",
                  placeholder: "Pilih komoditas",
                  modelValue: _ctx.form.commodity,
                  "onUpdate:modelValue": [
                    _cache[55] || (_cache[55] = ($event: any) => (_ctx.form.commodity = $event)),
                    _ctx.onChangeCommodity
                  ],
                  key: _ctx.resetSelectSearch
                }, null, 8, ["onFocus", "onFilter", "isLoading", "options", "modelValue", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isStatusGoodTax)
            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                _hoisted_78,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusGoodTaxOptions, (option) => {
                  return (_openBlock(), _createBlock("div", {
                    key: option.value,
                    class: "flex flex-col gap-y-4 mx-2 my-4 city-exclude-radio"
                  }, [
                    _createVNode("div", _hoisted_79, [
                      _createVNode(_component_RadioButton, {
                        id: `radio-${option.value}`,
                        name: "city-exclude",
                        value: option.value,
                        modelValue: _ctx.form.statusGoodTax,
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.form.statusGoodTax = $event)),
                        onChange: _ctx.onChangeStatusGoodTaxValue
                      }, null, 8, ["id", "value", "modelValue", "onChange"]),
                      _createVNode("label", {
                        for: `radio-${option.value}`,
                        class: "cursor-pointer"
                      }, _toDisplayString(option.name), 9, ["for"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isTopupVerification)
            ? (_openBlock(), _createBlock("div", _hoisted_80, [
                _createVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.partnerNameOpened,
                    "onUpdate:isExpand": _cache[57] || (_cache[57] = ($event: any) => (_ctx.partnerNameOpened = $event)),
                    options: _ctx.partnerNameOptions,
                    onSelect: _ctx.onSelectPartnerName,
                    placeholder: "Pilih nama partner",
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.partnerName
                  }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
                ]),
                _createVNode("div", _hoisted_83, [
                  _createVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('bookingShipment.list.filter.status')), 1),
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.topupStatusOpened,
                    "onUpdate:isExpand": _cache[58] || (_cache[58] = ($event: any) => (_ctx.topupStatusOpened = $event)),
                    options: _ctx.topupStatusOptions,
                    onSelect: _ctx.onSelectTopupStatus,
                    placeholder: _ctx.$t('bookingShipment.list.filter.selectStatus'),
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.topupStatus
                  }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                ]),
                _createVNode("div", _hoisted_85, [
                  _hoisted_86,
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.bankNameOpened,
                    "onUpdate:isExpand": _cache[59] || (_cache[59] = ($event: any) => (_ctx.bankNameOpened = $event)),
                    options: _ctx.bankNameOptions,
                    onSelect: _ctx.onSelectBankName,
                    placeholder: "Pilih bank penerima",
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.bankName
                  }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
                ]),
                _createVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.verificationTopupByOpened,
                    "onUpdate:isExpand": _cache[60] || (_cache[60] = ($event: any) => (_ctx.verificationTopupByOpened = $event)),
                    options: _ctx.verificationTopupByOptions,
                    onSelect: _ctx.onSelectVerificationTopupBy,
                    placeholder: "Pilih nama",
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.verificationTopupBy
                  }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isTopupApproval)
            ? (_openBlock(), _createBlock("div", _hoisted_89, [
                _createVNode("div", _hoisted_90, [
                  _createVNode("div", _hoisted_91, _toDisplayString(_ctx.$t('bookingShipment.list.filter.status')), 1),
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.topupStatusOpened,
                    "onUpdate:isExpand": _cache[61] || (_cache[61] = ($event: any) => (_ctx.topupStatusOpened = $event)),
                    options: _ctx.topuspApprovalStatusOptions,
                    onSelect: _ctx.onSelectTopupStatus,
                    placeholder: _ctx.$t('bookingShipment.list.filter.selectStatus'),
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.topupStatus
                  }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                ]),
                _createVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.bankNameOpened,
                    "onUpdate:isExpand": _cache[62] || (_cache[62] = ($event: any) => (_ctx.bankNameOpened = $event)),
                    options: _ctx.bankNameOptions,
                    onSelect: _ctx.onSelectBankName,
                    placeholder: "Pilih bank penerima",
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.bankName
                  }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
                ]),
                _createVNode("div", _hoisted_94, [
                  _hoisted_95,
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.verificationTopupByOpened,
                    "onUpdate:isExpand": _cache[63] || (_cache[63] = ($event: any) => (_ctx.verificationTopupByOpened = $event)),
                    options: _ctx.verificationTopupByOptions,
                    onSelect: _ctx.onSelectVerificationTopupBy,
                    placeholder: "Pilih nama",
                    class: "w-full custom-select",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.verificationTopupBy
                  }, null, 8, ["isExpand", "options", "onSelect", "selectedItem"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isMessagingEventStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_96, [
                _hoisted_97,
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.messagingEventStatusOptions,
                  onSelect: _ctx.onSelectMessagingEventStatus,
                  placeholder: "Pilih",
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.messagingEventStatus
                }, null, 8, ["options", "onSelect", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isMessagingMessageStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_98, [
                _hoisted_99,
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.messagingMessageStatusOptions,
                  onSelect: _ctx.onSelectMessagingMessageStatus,
                  placeholder: "Pilih",
                  class: "w-full custom-select",
                  isCustomWidth: "",
                  selectedItem: _ctx.filterData.messagingMessageStatus
                }, null, 8, ["options", "onSelect", "selectedItem"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isButtonApply)
            ? (_openBlock(), _createBlock("div", _hoisted_100, [
                _createVNode("div", _hoisted_101, [
                  _createVNode(_component_LpButton, {
                    color: "white",
                    textColor: "red-lp-100",
                    title: "Reset",
                    customClass: "border border-red-lp-100",
                    outline: "",
                    onClick: _ctx.resetToDefaultFilter,
                    isWidthFull: ""
                  }, null, 8, ["onClick"])
                ]),
                _createVNode("div", _hoisted_102, [
                  _createVNode(_component_LpButton, {
                    color: "red-lp-100",
                    textColor: "white",
                    title: "Terapkan",
                    onClick: _ctx.applyFilter,
                    isWidthFull: ""
                  }, null, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 6)
      ], 512), [
        [_vShow, _ctx.openFilter && !_ctx.isDisabled && !_ctx.isSeparateContent]
      ])
    ], 2),
    _withDirectives(_createVNode("div", {
      class: "absolute z-50 mt-4 bg-white",
      style: `width: ${_ctx.widthSeparateContent};`
    }, [
      _createVNode("div", {
        class: `select bg-white border border-gray-lp-400 rounded-md ${_ctx.isScroll && 'overflow-y-auto'} overflow-x-show`,
        style: { maxHeight: _ctx.customMaxHeightSeparateContent }
      }, [
        _renderSlot(_ctx.$slots, "custom-filter", {}, undefined, true)
      ], 6)
    ], 4), [
      [_vShow, _ctx.openFilter && !_ctx.isDisabled && _ctx.isSeparateContent]
    ])
  ], 512)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.openFilter = false;
          _ctx.$emit('opened', false);
        }
      }
    ]
  ])
})